import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import SetupSharingPanel from './SetupSharingPanel';

const SharingPanelBridge = react2angular(SetupSharingPanel, [
  'targetTypeName',
  'initialPublicType',
  'publicShareableUrl',
  'iframeTag',
  'onPublicTypeChange'
]);

export default SharingPanelBridge;
